(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[32116],{

/***/ 319326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme }) => [
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F,
  `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
`
]);
const CardHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const CardBody = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const CardFooter = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const Card = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, { children, header, footer, className } = _b, props = __objRest(_b, ["children", "header", "footer", "className"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, __spreadValues({
    className: (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeCls */ .c8)("teko-card", className || ""),
    ref
  }, props), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardHeader, {
    className: "teko-card-header"
  }, header), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardBody, {
    className: "teko-card-body"
  }, children), footer && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardFooter, {
    className: "teko-card-footer"
  }, footer));
});
Card.displayName = "Card";




/***/ }),

/***/ 982226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);
/* harmony import */ var _Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(208984);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${_Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BREAK_POINTS.xl */ .d.xl}) {
    width: ${(props) => props.fluid ? "100%" : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(props.maxWidth || "")};
  }
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    maxWidth,
    fluid,
    ref
  }, others), children);
});
Container.displayName = "Container";




/***/ }),

/***/ 842918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29921);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(917709);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const RightOutlined = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(64871), __webpack_require__.e(80710)]).then(__webpack_require__.bind(__webpack_require__, 564871)).then((mod) => mod.RightOutlined));
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(({
  isMobile,
  theme,
  backgroundColor
}) => `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${!isMobile ? `
          padding-left: ${theme.spacing.s16};
          padding-right: ${theme.spacing.s16};
          ` : ""}
  height: ${isMobile ? "2.75rem" : "3.5rem"};
  background-color: ${backgroundColor};
`);
const SeeAll = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ theme, color }) => `
    cursor: pointer;
    color: ${theme.colors[color] || theme.colors.textSecondary};
`);
const BlockHeader = ({
  title,
  titleColor,
  link,
  backgroundColor = "unset",
  tracking,
  className,
  style
}) => {
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .useDevice */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className,
    isMobile,
    backgroundColor,
    style
  }, link ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SeeAll, __spreadValues({
    color: link.color || ""
  }, tracking), (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Xem t\u1EA5t c\u1EA3"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RightOutlined, {
    color: link.color
  })))) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title));
};




/***/ }),

/***/ 788925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(675601);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EnhancedImage = (props) => {
  const _a = props, { link, tracking } = _a, rest = __objRest(_a, ["link", "tracking"]);
  const img = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadValues(__spreadValues({}, rest), !!tracking ? { tracking } : {}));
  return (link == null ? void 0 : link.href) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadValues({}, link), img) : img;
};




/***/ }),

/***/ 472522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ MenuPanel; },
/* harmony export */   "K": function() { return /* binding */ MAX_MENU_ITEMS; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(212951);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(428247);
/* harmony import */ var _helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(369985);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(675601);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(788925);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MEGA_MENU_BANNER_WIDTH = "14.625rem";
const MAX_MENU_ITEMS = 15;
const MenuPanel = ({
  menu,
  activeMenu,
  className,
  type,
  onClickMenuItem
}) => {
  var _a, _b, _c, _d;
  if (!menu.length)
    return null;
  const col = (item) => {
    return item.map((it, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuLv2, {
      key: it.name + `-${index}`,
      onClick: onClickMenuItem
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadValues({}, it.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
      level: 1,
      line: 1,
      color: "primary500",
      marginBottom: "s8"
    }, it.name)), it.children.map((subItem, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, subItem.link), {
      key: index2
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, subItem.name)))));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuPanelWrapper, {
    isDisplay: !!activeMenu && (!!((_a = activeMenu.banner) == null ? void 0 : _a.src) || !!((_b = activeMenu.children) == null ? void 0 : _b.length)),
    className
  }, menu.slice(0, MAX_MENU_ITEMS).map((menuItem, index) => {
    const getMenuColumns = () => {
      var _a2;
      let totalCols = 6;
      if (type === "vertical")
        totalCols--;
      if ((_a2 = menuItem == null ? void 0 : menuItem.banner) == null ? void 0 : _a2.src)
        totalCols--;
      return totalCols;
    };
    const newMenu = (0,_helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_3__/* .convertMegaMenu */ .R)(menuItem, getMenuColumns());
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuItemsWrapper, __spreadValues({
      key: index,
      isActive: menuItem === activeMenu
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      regionName: "megaMenuText",
      isTrackContent: true
    })), newMenu.map((menu2, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Column, {
      key: index2
    }, col(menu2.column))));
  }), ((_c = activeMenu == null ? void 0 : activeMenu.banner) == null ? void 0 : _c.src) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadValues({}, (_d = activeMenu.banner) == null ? void 0 : _d.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_5__/* .EnhancedImage */ .N, {
    src: activeMenu.banner.src,
    width: MEGA_MENU_BANNER_WIDTH,
    height: "100%",
    googleImageParams: {
      width: 400
    },
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      regionName: "megaMenuBanner",
      isTrackContent: true
    })
  })));
};
const Text = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  margin-bottom: 4px;
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const MenuPanelWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme, isDisplay }) => `
  background-color: ${theme == null ? void 0 : theme.colors.white};
  display: ${isDisplay ? "flex" : "none"};
`);
const MenuItemsWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme, isActive }) => `
  display: ${isActive ? "flex" : "none"};
  flex: 1;
  padding: ${theme == null ? void 0 : theme.spacing.s12};
`);
const MenuLv2 = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  margin-bottom: 1.5rem;
`;
const Column = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  width: 25%;
  padding: 0 8px;
`;




/***/ }),

/***/ 675601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TekoLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(456933);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(987900);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const serverless = typeof window !== "undefined";
const normalizeUrl = (url) => {
  if (!serverless || !url || typeof url !== "string")
    return url;
  if (url.match(/^https?:\/\/([^/]+)/)) {
    const urlObj = new URL(url);
    if (urlObj.hostname === window.location.host) {
      return `${urlObj.pathname}${urlObj.search}`;
    }
  }
  return url;
};
const TekoLink = (_a) => {
  var _b = _a, {
    children,
    href,
    as,
    prefetch = false
  } = _b, rest = __objRest(_b, [
    "children",
    "href",
    "as",
    "prefetch"
  ]);
  const [newState, setNewState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    pathname: (typeof href === "string" ? href : href == null ? void 0 : href.pathname) || "",
    query: {},
    as
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    async function init() {
      if (!href)
        return;
      href = normalizeUrl(href);
      as = normalizeUrl(as);
      if (typeof href === "string") {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUrlObject */ .Bi)(href));
        if (!result.pathname) {
          result.pathname = href;
        }
        setNewState(__spreadProps(__spreadValues({}, result), { as: as || href }));
      } else {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)(href);
        if (!result.pathname && (href == null ? void 0 : href.pathname)) {
          result.pathname = href.pathname;
        }
        setNewState(__spreadProps(__spreadValues(__spreadValues({}, href), result), {
          as: as || ((href == null ? void 0 : href.pathname) ? href : null) || void 0
        }));
      }
    }
    init();
  }, [href, as, setNewState]);
  if (!href) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  if (serverless) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadValues({
      "data-testid": "TekoLink",
      href: { pathname: newState.pathname, query: newState.query },
      as: newState.as,
      prefetch
    }, rest), children);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadProps(__spreadValues({
    "data-testid": "TekoLink",
    href: href || "",
    as
  }, rest), {
    prefetch
  }), children);
};
const StyledLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])((next_link__WEBPACK_IMPORTED_MODULE_1___default()))`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F}
  color: black;
  text-decoration: none;
`;




/***/ }),

/***/ 369985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ convertMegaMenu; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const convertMegaMenu = (menu, numberCol) => {
  if (numberCol < 1)
    return [];
  const newArr = menu.children.map((m) => {
    return {
      len: m.children.length + 1,
      column: [__spreadValues({}, m)]
    };
  });
  if (newArr.length <= numberCol)
    return newArr;
  newArr.sort((a, b) => b.len - a.len);
  const result = [...newArr.slice(0, numberCol)];
  let min;
  let k;
  for (let i = numberCol; i < newArr.length; i++) {
    min = result[0].len;
    k = 0;
    for (let j = 0; j < numberCol; j++) {
      if (min > result[j].len) {
        min = result[j].len;
        k = j;
      }
    }
    result[k] = {
      len: result[k].len + newArr[i].len,
      column: [...result[k].column, ...newArr[i].column]
    };
  }
  return result;
};




/***/ }),

/***/ 29921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Thu gọn": "Collapse",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time",
	"Tìm kiếm gần đây": "Recent search",
	"Chọn khu vực nhận hàng": "Select the location",
	"Vui lòng chọn khu vực nhận hàng của bạn": "Please select your location",
	"Tìm kiếm Tỉnh/ Thành phố": "Search Province/City",
	"Không tìm thấy tỉnh thành phố nào !!": "No provice/city is found !!",
	"Khi thay đổi thông tin đơn hàng thanh toán lại, đơn hiện tại sẽ bị hủy. Giá và khuyến mại đơn hàng có thể bị thay đổi. Bạn có chắc chắn muốn thực hiện thao tác này?": "When changing payment order information, current order will be canceled. Order prices and promotions are subject to change. Are you sure you want to perform this action?",
	"Trường hợp muốn thay đổi hình thức thanh toán hoặc các thông tin khác, vui lòng": "If you want to change your payment configuration or other information, please",
	"Bấm vào đây": "Click here",
	"Xem chi tiết": "View detail",
	"Cần thanh toán": "Need to pay",
	"Giao hàng bởi": "Delivered by",
	"Mã vận đơn": "Shipment code",
	"Cung cấp bởi": "Provided by",
	"Combo giảm ~": "Combo discount ~"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "teko-ecommerce";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), { ns: NAMESPACE }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 307411:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/categories",
      function () {
        return __webpack_require__(813015);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 101763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ buildTreeCategories; },
/* harmony export */   "q": function() { return /* binding */ convertMegaMenuItem; }
/* harmony export */ });
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(875663);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(788813);
/* harmony import */ var _teko_slug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93512);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const convertUrl = (targetPath, urlType, isTargetBlank)=>{
    if (!targetPath) {
        return undefined;
    }
    if (urlType === "rewrite") {
        return {
            href: "/search?router=productListing&" + targetPath,
            target: isTargetBlank ? "_blank" : "_self"
        };
    }
    return {
        href: targetPath,
        target: isTargetBlank ? "_blank" : "_self"
    };
};
const getMenuItemUrl = (item)=>{
    const { isTargetBlank , url , targetPath , urlType  } = item || {};
    const target = isTargetBlank ? "_blank" : "_self";
    const href = url || (urlType === "rewrite" ? "/search?router=productListing&" + targetPath : targetPath);
    return {
        href,
        target
    };
};
const getUrl = (item)=>{
    const { isTargetBlank , url  } = item || {};
    const target = isTargetBlank ? "_blank" : "_self";
    if (!url) return null;
    return {
        href: url,
        target
    };
};
const convertUrlParamsToObject = (urlParams)=>{
    const urlParamsArray = Array.from(urlParams);
    return urlParamsArray.reduce((acc, cur)=>_objectSpreadProps(_objectSpread({}, acc), {
            [cur[0]]: cur[1]
        }), {});
};
const computeBlockPageUrl = (menu)=>{
    var ref;
    if (!menu.targetPath || menu.urlType !== "rewrite") {
        return null;
    }
    const menuConfig = menu.configs;
    const targetFilterParams = convertUrlParamsToObject(new URLSearchParams(menu.targetPath));
    // targetPath has only 1 filter config
    if (((ref = Object.keys(targetFilterParams)) === null || ref === void 0 ? void 0 : ref.length) === 1) {
        var ref1;
        const filterKey = Object.keys(targetFilterParams)[0];
        const filterValue = ((ref1 = menuConfig[filterKey]) === null || ref1 === void 0 ? void 0 : ref1.length) === 1 ? menuConfig[filterKey][0] : null;
        if (!filterValue) {
            return null;
        }
        switch(filterKey){
            case "brands":
                return {
                    href: {
                        pathname: "/brands/[brandId]",
                        query: {
                            brandId: filterValue
                        }
                    },
                    target: menu.isTargetBlank ? "_blank" : "_self",
                    as: {
                        pathname: (0,___WEBPACK_IMPORTED_MODULE_0__/* .buildSlugUrl */ .hH)(_teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.BRAND */ .DZ.BRAND, menu.name, filterValue)
                    },
                    shallow: true
                };
            case "masterCategoryIds":
                return {
                    href: {
                        pathname: "/block-categories/[categoryId]",
                        query: {
                            categoryId: filterValue
                        }
                    },
                    target: menu.isTargetBlank ? "_blank" : "_self",
                    as: (0,___WEBPACK_IMPORTED_MODULE_0__/* .buildSlugUrl */ .hH)(_teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.CATEGORY */ .DZ.CATEGORY, menu.name, filterValue) || undefined,
                    shallow: true
                };
            case "sellerIds":
                return {
                    href: {
                        pathname: "/sellers/[sellerId]",
                        query: {
                            sellerId: filterValue
                        }
                    },
                    target: menu.isTargetBlank ? "_blank" : "_self",
                    as: (0,___WEBPACK_IMPORTED_MODULE_0__/* .buildSlugUrl */ .hH)(_teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.SELLER */ .DZ.SELLER, menu.name, filterValue) || undefined,
                    shallow: true
                };
            case "categories":
                return {
                    href: {
                        pathname: "/seller-categories/[sellerCategoryId]",
                        query: {
                            sellerCategoryId: filterValue
                        }
                    },
                    target: menu.isTargetBlank ? "_blank" : "_self",
                    as: "/".concat((0,_teko_slug__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(menu.name), "-scat.").concat(filterValue),
                    shallow: true
                };
            default:
                return null;
        }
    }
    return null;
};
const convertMegaMenuItem = (item)=>{
    var ref, ref1, ref2, ref3, ref4;
    return {
        id: item.id,
        name: item.name,
        icon: item.icon,
        link: getUrl(item) || computeBlockPageUrl(item) || getMenuItemUrl(item),
        banner: !!((ref = item.banners) === null || ref === void 0 ? void 0 : ref.length) ? {
            src: (ref1 = item.banners[0]) === null || ref1 === void 0 ? void 0 : ref1.image,
            hoverEffect: "zoom",
            link: convertUrl((ref2 = item.banners[0]) === null || ref2 === void 0 ? void 0 : ref2.targetPath, (ref3 = item.banners[0]) === null || ref3 === void 0 ? void 0 : ref3.urlType)
        } : undefined,
        children: ((ref4 = item.children) === null || ref4 === void 0 ? void 0 : ref4.map(convertMegaMenuItem)) || []
    };
};
const getValidBanners = (banners)=>{
    return banners.filter((banner)=>{
        if (!banner.isActive) return false;
        const currentTime = new Date().getTime();
        if (banner === null || banner === void 0 ? void 0 : banner.startDate) {
            if (!(banner === null || banner === void 0 ? void 0 : banner.endDate)) {
                return currentTime >= banner.startDate * 1000;
            }
            return banner.startDate * 1000 <= currentTime && banner.endDate * 1000 >= currentTime;
        }
        if (banner === null || banner === void 0 ? void 0 : banner.endDate) {
            return currentTime <= banner.endDate * 1000;
        }
        return true;
    });
};
const buildTreeCategories = (menuItems)=>{
    const rootMenuItems = menuItems.filter((param)=>{
        let { parentId  } = param;
        return !parentId;
    });
    const buildMenuItem = (root)=>{
        const children = menuItems.filter((param)=>{
            let { parentId  } = param;
            return parentId === root.id;
        });
        return _objectSpreadProps(_objectSpread({}, root), {
            banners: getValidBanners(root.banners || []),
            children: children.map(buildMenuItem)
        });
    };
    return rootMenuItems.map((root)=>buildMenuItem(root));
};


/***/ }),

/***/ 770353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "w": function() { return /* binding */ useIdentifiedPage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);

const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
const useIdentifiedPage = (className)=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const node = document.createElement("div");
        node.className = className;
        node.style.display = "none";
        document.body.prepend(node);
        return ()=>node.remove();
    }, []);
};


/***/ }),

/***/ 813015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ desktop_categories; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Card/Card.es.js
var Card_es = __webpack_require__(319326);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/BlockHeader/BlockHeader.es.js
var BlockHeader_es = __webpack_require__(842918);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/MegaMenu/MenuPanel.es.js
var MenuPanel_es = __webpack_require__(472522);
// EXTERNAL MODULE: ./helpers/menuItem.ts
var menuItem = __webpack_require__(101763);
// EXTERNAL MODULE: ./hooks/common.ts
var common = __webpack_require__(770353);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/head.js
var head = __webpack_require__(979894);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./modules/categories/desktop/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








const Categories = (param)=>{
    let { serverCategoryList  } = param;
    const categoryList = serverCategoryList || [];
    (0,common/* useIdentifiedPage */.w)("category");
    if (!categoryList.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "robots",
                    content: "noindex, nofollow"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_es/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_es/* Card */.Z, {
                    marginTop: "s40",
                    marginBottom: "s40",
                    padding: "s8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader_es/* BlockHeader */.t, {
                            title: (0,i18n.t)("Danh mục sản phẩm")
                        }),
                        categoryList.map((item, index)=>{
                            const convertedMenu = (0,menuItem/* convertMegaMenuItem */.q)(item);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                                        paddingLeft: "s16",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, _objectSpreadProps(_objectSpread({}, convertedMenu.link), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Heading */.X6, {
                                                level: 4,
                                                children: convertedMenu.name
                                            })
                                        }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuPanel_es/* MenuPanel */.G, {
                                        menu: [
                                            convertedMenu
                                        ],
                                        activeMenu: convertedMenu,
                                        type: "vertical"
                                    }, index)
                                ]
                            }, item.id);
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./tenants/_template/desktop/categories.tsx


const getServerSideProps = (/* unused pure expression or super */ null && (getServerSideCategories));
/* harmony default export */ var categories = (Categories);

;// CONCATENATED MODULE: ./pages/default/desktop/categories.tsx
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ var desktop_categories = (categories);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [93712,49774,92888,40179], function() { return __webpack_exec__(307411); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);